import React from 'react';
import { Phone, Wrench, Shield, CheckCircle, Clock, Zap } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Link } from 'react-router-dom';

import SeoNav from '../components/seo/SeoNav';
import FAQSection from '../components/seo/FAQSection';
import { CtaSection, SeoFooter } from '../components/seo/CtaFooter';

const FAQ = [
  { q: "Combien coûte la réparation d'un connecteur de charge ?", r: "Le prix varie selon le modèle de votre téléphone (iPhone, Samsung, etc.). Contactez-nous pour un devis gratuit précis au 07.73.60.15.21. Nos tarifs sont compétitifs et transparents." },
  { q: "Combien de temps dure la réparation ?", r: "La réparation d'un connecteur de charge prend généralement entre 30 et 60 minutes. Nous intervenons le jour même dans la plupart des cas." },
  { q: "Quelle est la garantie sur la réparation ?", r: "Toutes nos réparations de connecteur de charge sont garanties 3 mois contre tout dysfonctionnement lié à la pièce ou à l'intervention." },
  { q: "Est-ce que vous réparez tous les modèles ?", r: "Oui, nous réparons le connecteur de charge sur iPhone, Samsung, Huawei, Xiaomi, Oppo et la plupart des autres marques. Contactez-nous pour confirmer la disponibilité pour votre modèle." },
  { q: "Comment savoir si c'est le connecteur ou la batterie ?", r: "Nous effectuons un diagnostic gratuit pour identifier précisément le problème. Parfois, les symptômes de charge peuvent être causés par la batterie, le connecteur ou même le logiciel." },
  { q: "Puis-je nettoyer moi-même le port de charge ?", r: "Nous vous déconseillons de le faire vous-même, car vous risquez d'endommager les contacts délicats. Nous proposons un nettoyage professionnel gratuit lors du diagnostic." },
];

const ReparationConnecteurChargeSaintChamond = () => {
  return (
    <div className="min-h-screen bg-white">
      <SeoNav />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#1a2332] via-[#1e2a3d] to-[#1a2332] text-white py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Réparation Connecteur de Charge Saint-Chamond
            </h1>
            <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
              Votre téléphone ne charge plus ? Réparation rapide du connecteur de charge à Saint-Chamond - Intervention le jour même
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a href="tel:0773601521" className="w-full sm:w-auto">
              <Button className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white px-10 py-6 text-lg rounded-xl transition-all font-bold shadow-xl">
                <Phone className="w-5 h-5 mr-2" />
                Appeler maintenant
              </Button>
            </a>
            <Link to="/rendez-vous" className="w-full sm:w-auto">
              <Button className="w-full sm:w-auto bg-blue-500 hover:bg-blue-600 text-white px-10 py-6 text-lg rounded-xl transition-all font-bold shadow-xl">
                Prendre rendez-vous
              </Button>
            </Link>
            <a href="https://wa.me/33773601521" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto">
              <Button className="w-full sm:w-auto bg-[#25D366] hover:bg-[#20BD5A] text-white px-10 py-6 text-lg rounded-xl transition-all font-bold shadow-xl">
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                WhatsApp
              </Button>
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <Clock className="w-8 h-8 text-blue-400 mx-auto mb-2" />
              <div className="text-2xl font-bold">30-60 min</div>
              <div className="text-sm text-gray-300">Réparation rapide</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <Shield className="w-8 h-8 text-green-400 mx-auto mb-2" />
              <div className="text-2xl font-bold">3 mois</div>
              <div className="text-sm text-gray-300">Garantie</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <Wrench className="w-8 h-8 text-yellow-400 mx-auto mb-2" />
              <div className="text-2xl font-bold">Premium</div>
              <div className="text-sm text-gray-300">Pièces d'origine</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
              <Zap className="w-8 h-8 text-purple-400 mx-auto mb-2" />
              <div className="text-2xl font-bold">Jour même</div>
              <div className="text-sm text-gray-300">Intervention</div>
            </div>
          </div>
        </div>
      </section>

      {/* Problèmes courants */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Votre téléphone ne charge plus ?
            </h2>
            <p className="text-lg text-gray-600">Symptômes courants d'un connecteur de charge défectueux</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card className="hover:shadow-xl transition-shadow">
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Charge intermittente</h3>
                <p className="text-gray-600">
                  Votre téléphone se charge seulement dans certaines positions du câble ?
                </p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-xl transition-shadow">
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-orange-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Pas de reconnaissance</h3>
                <p className="text-gray-600">
                  Le téléphone ne détecte pas le chargeur branché ?
                </p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-xl transition-shadow">
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-yellow-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Charge très lente</h3>
                <p className="text-gray-600">
                  La batterie met des heures à se recharger complètement ?
                </p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-xl transition-shadow">
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Port endommagé</h3>
                <p className="text-gray-600">
                  Le connecteur est déformé, cassé ou ne tient plus le câble ?
                </p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-xl transition-shadow">
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-purple-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Poussières et débris</h3>
                <p className="text-gray-600">
                  Le port de charge est obstrué par des poussières ou débris ?
                </p>
              </CardContent>
            </Card>

            <Card className="hover:shadow-xl transition-shadow">
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                  <CheckCircle className="w-6 h-6 text-green-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Erreur de charge</h3>
                <p className="text-gray-600">
                  Message d'erreur "Accessoire non supporté" ou "Liquide détecté" ?
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Notre solution */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Notre solution : Réparation professionnelle
            </h2>
            <p className="text-lg text-gray-600">Intervention rapide et garantie 3 mois</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <Card className="bg-white shadow-lg">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Wrench className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Diagnostic gratuit</h3>
                <p className="text-gray-600">
                  Nous identifions précisément le problème : connecteur, batterie ou autre composant.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white shadow-lg">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Clock className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Réparation rapide</h3>
                <p className="text-gray-600">
                  Remplacement du connecteur de charge en 30 à 60 minutes. Intervention le jour même.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white shadow-lg">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Shield className="w-8 h-8 text-purple-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Garantie 3 mois</h3>
                <p className="text-gray-600">
                  Toutes nos réparations sont garanties 3 mois. Travail professionnel assuré.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <FAQSection titre="Questions fréquentes" items={FAQ} sousTitre="Tout savoir sur la réparation du connecteur de charge" bg="bg-white" />

      <CtaSection titre="Votre téléphone ne charge plus ?" texte="Contactez-nous maintenant pour un diagnostic gratuit et une réparation rapide à Saint-Chamond." />

      {/* Footer */}
      <SeoFooter texte="© 2026 Suro Phone - Réparation Connecteur de Charge Saint-Chamond" />
    </div>
  );
};

export default ReparationConnecteurChargeSaintChamond;